$(function() {
// タブ、または日本地図をクリックで表示する地域を変更。
$(".shakatsu-nav__btn a, area").on('click', function() {
var href = $(this).attr("href");
var i = parseInt(href.slice(-1) - 1);

// 今表示されているブロックを非表示にさせる。
$($(".shakatsu-nav__btn .active").attr("href")).hide();
$(".shakatsu-nav__btn .active").removeClass("active");

// ボタンに「active」というクラスを付ける。
$('.shakatsu-nav__btn [href="'+href+'"]').addClass("active");

// 押したボタン、画像と対応するブロックが表示される。
$(href).fadeIn("slow");

// 選択されている地域の画像がハイライトされている日本地図に変更。
$('img.j_map').attr('src', '/inc/image/shakatsu-blog/japan-map_0'+i+'.png');

return false;
});


// 端末を調べる関数。
function getDevice() {
var ua = navigator.userAgent;

if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
return 'sp';
}
else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
return 'tab';
}
else {
return 'other';
}
}

// 端末名を変数に格納。
var device = getDevice();

// 端末がPCの時のホバー時の処理を設定。
if (device === 'other') {
$('map[name="ImageMap"] area').on('mouseenter', function() {
var href = $(this).attr('href');
var i = parseInt(href.slice(-1) - 1);

// 日本地図にマウスが入ると、ホバー用画像を表示。
$(".shakatsu-map__img .container_j_map").append('<img src="/inc/image/shakatsu-blog/japan-map_hover_0'+i+'.png" class="is-hover">');
});

// 日本地図からマウスが離れたら、ホバー用画像が消える。
$('map[name="ImageMap"] area').on('mouseleave', function() {
$(".is-hover").remove();
});
}


// ブラウザを判定する関数。
function getBrowser() {
// 判定をするにあたって、文字列をすべて小文字にしておきます。
var ua = navigator.userAgent.toLowerCase();

// 「chrome」という文字列はEdgeやOperaのユーザーエージェントにも含まれているため、
// ユーザーエージェントに「chrome」という文字列が入っていて、かつ、「edge/opr」が入っていないことで「Chrome」だと確認可能。
if (ua.indexOf('chrome') !== -1 && ua.indexOf('edge') === -1 && ua.indexOf('opr') === -1) {
return "chrome";
}
else if (ua.indexOf('firefox') !== -1) {
return 'firefox';
}
else if (ua.indexOf("edge") !== -1) {
return "edge";
}
// IE は「msie」という文字列で判別できるが、IE11 から「msie」が削除され「trident」が追加されたので下のようにする。
else if (ua.indexOf("msie") !== -1 || ua.indexOf("trident") !== -1) {
return "ie";
}
else {
return "other";
}
}

var browser = getBrowser();

// 「area」を選択したら選択を外すことで、クリッカブルマップの枠線を消す（IE のため）。
// ただし「firefox」ではこれを書くことで、逆に枠線が出るようになるので、「firefox」以外に実行する。
if (browser !== "firefox") {
$("area").focus(function(){
$("area").blur();
});
}
});